<div [formGroup]="formGroup">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <div class="row">
          <div class="row col-sm-12">
            <h3 class="col-sm-7">Secured Asset collateral details</h3>
            <p *ngIf="isGreen" class="col-sm-5 d-flex align-items-end justify-content-end text-success"><i
                class="material-icons">eco</i> <i>green vehicle</i></p>
          </div>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>

      <div class="row" *ngIf="(originatorDetails?.id === LCA_ORIGINATOR_PARTY_ROLE_ID) || (!caravanDisabled && originatorDetails?.id !== LCA_ORIGINATOR_PARTY_ROLE_ID)">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Vehicle type</mat-label>
            <mat-select placeholder="Vehicle type" formControlName="vehicleType"
              (selectionChange)="updateVehicleType($event.value)">
              <mat-option *ngFor="let type of motorVehicleClasses" [value]="type?.id">{{type?.text}}</mat-option>
            </mat-select>
          </mat-form-field>
          <span class="text-secondary" *ngIf="formGroup.get('vehicleType').value === 'caravan'">This product is available for home owners only.</span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-7">
          <fmc-car-search [placeholderText]="'Secured asset search'" [parentFormGroup]="formGroup"
            [controlName]="'vehicle'" [disable]="!formGroup.get('vehicleType').value"
            [collateralClass]="formGroup.get('vehicleType').value"
            [vehicleType]="formGroup.get('vehicleType').value"></fmc-car-search>
          <span class="text-secondary" *ngIf="formGroup.get('vehicleType').value === 'caravan'">The selected product is limited to vehicles 7 years and below.</span>
        </div>
        <div class="col-5">
          <mat-form-field appearance="outline">
            <mat-label>VIN</mat-label>
            <input matInput placeholder="VIN" formControlName="vin">
            <mat-error>
              <app-validation-partial [formGroup]="formGroup" [fieldName]="'vin'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label class="mb-0" style="color: rgba(0, 0, 0, 0.54);"><small>Variant</small></mat-label>
            <select class="full-select" matNativeControl formControlName="variant" (change)="getVariantSpecs($event.target)">
              <option *ngIf="!variantTypes  || variantTypes.length === 0" selected [value]="null">Select Model to show variant</option>
              <option *ngIf="variantTypes.length > 0" selected [value]="null">Select Variant</option>
              <option *ngIf="formGroup.get('vehicleType').value === 'caravan'" [value]="'my-variant-is-not-listed'">My caravan is not in the list</option>
              <option *ngFor="let type of variantTypes" [value]="type.nvic">[{{type.nvic}}] {{type.name}}</option>
            </select>
          </mat-form-field>
        </div>
      </div>
      <div class="row"
        *ngIf="formGroup.get('vehicleType').value === 'car' && formGroup.get('vin').value && formGroup.get('purpose').value && formGroup.get('purpose').value !== 'purchase-new-personal'">
        <div class="col-12">
          <mat-form-field appearance="outline">
            <mat-label>Odometer</mat-label>
            <input matInput placeholder="Odometer" formControlName="odometerReading">
            <mat-error>
              <app-validation-partial [formGroup]="formGroup" [fieldName]="'odometerReading'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row mb-4"
        *ngIf="formGroup.get('vehicleType').value === 'car' && formGroup.get('vin').value && formGroup.get('purpose').value && formGroup.get('purpose').value !== 'purchase-new-personal'">
        <div class="col-12">
          <strong>ODO reading entered will be verified by Dealer Invoice (if buying a used car) or Photos of ODO reading (if refinancing)</strong>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <div class="row">
          <div class="col-sm-5">
            <h3>Loan details</h3>
          </div>
          <div class="col-sm-7 text-end">
            <small style="color:#f44336" *ngIf="productVariations.length === 0">
              Please complete secured asset search above for product list to appear
            </small>
          </div>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Loan purpose</mat-label>
            <mat-select placeholder="Loan purpose" formControlName="purpose" (selectionChange)="updatePurpose($event.value)">
              <mat-option *ngFor="let purpose of loanPurposes" [value]="purpose.id"
                [hidden]="!purpose.ext.active">{{purpose.ext.description}}</mat-option>
            </mat-select>
            <mat-error>
              <app-validation-partial [formGroup]="formGroup" [fieldName]="'purpose'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline">
            <mat-label>Select a product</mat-label>
            <mat-select placeholder="Select a product" formControlName="product" [disabled]="!enableProductList">
              <mat-option *ngFor="let product of productVariations" [value]="product.slug">
                {{product.pricing[0]?.displayName || product.name}}
              </mat-option>
            </mat-select>
            <mat-error>
              <app-validation-partial [formGroup]="formGroup" [fieldName]="'product'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <mat-form-field appearance="outline" *ngIf="
          formGroup.value.purpose &&
          formGroup.value.product &&
          formGroup.value.loanTermId &&
          formGroup.value.interestRate && formGroup.value.interestRate > 0">
            <mat-label>Interest rate</mat-label>
            <input matInput placeholder="Interest Rate" type="number" formControlName="interestRate" readonly>
            <span matSuffix>%</span>
            <mat-error>
              Please enter a rate between [{{rateData?.minInterestRateInput}}%] and
              [{{rateData?.maxInterestRateInput}}%]
              <!-- <app-validation-partial [formGroup]="formGroup" [fieldName]="'interestRate'"></app-validation-partial>
              <span *ngIf="formGroup.get('interestRate')?.errors?.max">&nbsp;- Max Interest rate:
                {{rateData?.FirstmacMaxBorrowingRate * 100}}%</span> -->
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex align-items-center">
          <mat-checkbox formControlName="homeOwnerDiscount">Apply home owner discount</mat-checkbox>
          <ng-container *ngIf="realEstateCountWithoutNas > 0">
            <mat-icon class="ms-2" matTooltip="You are eligible for a homeowner discount">info</mat-icon>
          </ng-container>
          <ng-container *ngIf="realEstateCountWithoutNas <= 0">
            <mat-icon class="ms-2" matTooltip="To be eligible for a homeowner discount, the borrower must own their own home or an investment property.">info</mat-icon>
          </ng-container>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        Repayment and loan term
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-sm-6">
          <mat-form-field appearance="outline">
            <mat-label>Select repayment</mat-label>
            <mat-select placeholder="Select repayment" formControlName="repaymentFrequency">
              <mat-option *ngFor="let repayment of repaymentTypes"
                [value]="repayment.id">{{repayment.text}}</mat-option>
            </mat-select>
            <mat-error>
              <app-validation-partial [formGroup]="formGroup"
                [fieldName]="'repaymentFrequency'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field appearance="outline">
            <mat-label>Select loan term</mat-label>
            <mat-select placeholder="Select loan term" formControlName="loanTermId"
              (selectionChange)="updateTerm($event.value)" [disabled]="!enableLoanTerms">
              <mat-option *ngFor="let term of loanTerms" [value]="term.slug">{{term.name}}</mat-option>
            </mat-select>
            <mat-error>
              <app-validation-partial [formGroup]="formGroup" [fieldName]="'loanTermId'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <mat-form-field appearance="outline">
            <mat-label>Monthly repayment</mat-label>
            <input matInput placeholder="Monthly repayment" formControlName="monthlyRepayment" readonly>
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field appearance="outline">
            <mat-label>Monthly fee</mat-label>
            <input matInput placeholder="Monthly fee" formControlName="monthlyFee" readonly>
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="offset-6 col-6">
          <mat-form-field appearance="outline">
            <mat-label>Total monthly repayment</mat-label>
            <input matInput placeholder="Total monthly repayment" formControlName="totalMonthlyRepayment" readonly>
            <button type="button" matSuffix mat-icon-button style="cursor: default"
              matTooltip="Inclusive of Monthly Fee">
              <mat-icon>info</mat-icon>
            </button>
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="formGroup.get('vehicleType').value === 'car'">
    <mat-card-header>
      <mat-card-title>
        Balloon amount
        <ng-container *ngIf="vehicleAge > 4">
          <small>Balloon not available for vehicles more than 4 years old<br /></small>
        </ng-container>
        <ng-container *ngIf="loanTermInYears > 5">
          <small>Balloon payment is not permitted for loans with a term greater than 5 years.</small>
        </ng-container>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col-sm-6">
          <mat-form-field appearance="outline">
            <mat-label>Select balloon percentage</mat-label>
            <mat-select placeholder="Select balloon percentage" formControlName="balloonPercentage"
              [disabled]="!enableBalloons || vehicleAge > 4" (selectionChange)="calculateBalloon()">
              <mat-option *ngFor="let balloon of allBalloons" [value]="balloon">{{balloon}} %</mat-option>
            </mat-select>
            <mat-error>
              <app-validation-partial [formGroup]="formGroup"
                [fieldName]="'balloonPercentage'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-6">
          <mat-form-field appearance="outline">
            <mat-label>Balloon amount</mat-label>
            <input matInput placeholder="Balloon amount" type="number" formControlName="balloonAmount"
              [readonly]="vehicleAge > 4">
            <span matPrefix>$&nbsp;</span>
            <span matSuffix>.00</span>
            <mat-error>
              <app-validation-partial [formGroup]="formGroup" [fieldName]="'balloonAmount'"></app-validation-partial>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
